<template>

    <div class="sa-list-component" style="height: 100% !important; padding: 8px;">
        <div class="sa-list-component-header">
            <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col lg="3">
                    <p>Records Totali: {{ rows }}</p>
                </b-col>
                <b-col lg="9">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right"
                        size="sm"></b-pagination>
                </b-col>
            </b-row>

        </div>
        <div class="sa-list-component-body">


            <b-card class="sa-card sa-card-border sa-card-list-scroll" header-tag="header" footer-tag="footer" title="">
                <template #header>
                    <div class="d-flex justify-content-between align-items-center custom-header">
                        <span>{{ completeBookingSsn ? 'Appuntamenti' : 'Accessi' }}</span>
                        <b-button size="sm" variant="success" @click="onClickAggiungiAccessoDiretto">Aggiungi
                            Accesso
                            Diretto</b-button>
                    </div>
                </template>
                <div class="b-table-sticky-header">
                    <b-table sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="fields"
                        :current-page="currentPage" :per-page="perPage" :key="listKey" sort-icon-left
                        head-variant="light" class="sa-b-table" sort-by="riferimento" :sort-desc="false"
                        :sort-compare="sortCompare">
                        <template #cell(riferimento)="row">
                            <strong style=" width: 100%; font-size: small; display: inline-block;">
                                {{ formatDate(row.item.dataOraInizio) }}
                            </strong>
                            <small style="display: inline-block; font-weight: 600;"> {{
                                getGiornoSettimana(row.item.dataRiferimento).toUpperCase() }}</small>
                            <br>
                            <strong style=" width: 100%; font-size: small; display: inline-block;">
                                {{ getOrario(row.item.dataOraInizio) }} - {{ getOrario(row.item.dataOraFine) }}
                            </strong>
                        </template>
                        <template #cell(identificativoAppuntamento)="row">
                            <b style="font-style: italic;">{{ row.item.identificativoAppuntamento }}</b>
                            <br />
                            <small>{{ row.item.cognome }} {{ row.item.nome }}</small>
                        </template>
                        <template #cell(nre)="row">
                            <span style="font-weight: 700; " v-if="row.item.codiceBar1 != 'PVT'">
                                <span style="width:100%; display: inline-block;">{{ row.item.codiceBar1 }} {{
                                    row.item.codiceBar2
                                }}</span>
                            </span>
                            <span v-else>
                                <span style="font-weight: 700; width:100%; display: inline-block;">{{
                                    row.item.codiceBar1 }} </span>
                                <span style="font-weight: 700; width:100%; display: inline-block;">
                                    {{ row.item.codiceBar2.toUpperCase()
                                    }}</span>
                            </span>
                        </template>


                        <template #cell(note)="row">
                            <div style="display:block; height:50px; overflow-y:auto; word-break:break-word;">
                                {{ row.item.note }}
                            </div>
                        </template>
                        <template #cell(descrizionePrestazione)="row">
                            <strong style="width: 100%; display: inline-block;">{{
                                row.item.descrizionePrestazione }}</strong>
                            <span style="font-size: small; display: inline-block;" v-if="completeBookingSsn">
                                {{ getInfoAgenda(row.item) }}
                            </span>
                            <span style="font-size: small; display: inline-block;" v-else>
                                {{ row.item.codicePrestazione }}
                            </span>
                        </template>
                        <template #cell(ciclo)="row">
                            <span style="font-size: small; display: inline-block; width: 100%;">
                                Accesso n° <b>{{ row.item.numeroOrdine }}</b>
                            </span>

                            <small v-if="completeBookingSsn">n° {{ row.item.numeroOrdine }} / {{
                                row.item.quantitaErogabile }} Accessi</small>
                            <small v-else>
                                {{ row.item.numeroOrdine }} / {{ getDescrizioneNumeroTotaleCiclo(row) }}
                            </small>
                        </template>
                        <template #cell(statoAttuale)="row">
                            <strong style="width: 100%;display: inline-block; ">{{ row.item.statoAttuale
                            }}</strong>

                            <span style="font-size: small; display: inline-block;">
                                {{ formatDate(row.item.statoAttualeDataOra) }}
                            </span>
                        </template>

                        <template #cell(actions)="row">
                            <b-container style="gap:8px">
                                <b-button variant="btn btn-info waves-effect waves-light width-sm no-text"
                                    @click="getInfoAccessoAppuntamento(row.item)">
                                    <b-icon icon="info"></b-icon>
                                </b-button>
                                <b-button v-if="completeBookingSsn"
                                    :disabled="row.item.statoAttuale == 'EROGATO' || row.item.statoAttuale == 'ESEGUITO' || row.item.statoAttuale == 'NON ESEGUITO'"
                                    variant="btn btn-primary waves-effect waves-light width-sm no-text"
                                    @click="onChangeStatoPrenotazione(row.item)">
                                    <i class="bi bi-arrow-repeat"></i>
                                </b-button>
                                <b-button v-if="completeBookingSsn"
                                    :disabled="row.item.statoAttuale == 'EROGATO' || row.item.statoAttuale == 'ESEGUITO' || row.item.statoAttuale == 'NON ESEGUITO'"
                                    variant="btn btn-purple waves-effect waves-light width-sm no-text"
                                    @click="gestioneAppuntamenti(row.item)">
                                    <b-icon icon="gear"></b-icon>
                                </b-button>

                                <b-button variant="btn btn-danger waves-effect waves-light width-sm no-text"
                                    @click="onClickEliminaAppuntamento(row.item)">
                                    <b-icon icon="trash"></b-icon>
                                </b-button>
                            </b-container>
                        </template>

                    </b-table>
                </div>
            </b-card>

            <b-modal ref="mdlInfo" @hide="onHideInfoModal" title="Informazioni" centered>
                <b-form>
                    <b-row>
                        <b-col cols="4">
                            <label class="sa-data-label">Nome</label>
                            <br />
                            <span>{{ this.accessoAppuntamentoSel.nome }}</span>
                        </b-col>
                        <b-col cols="4">
                            <label class="sa-data-label">Cognome</label>
                            <br />
                            <span>{{ this.accessoAppuntamentoSel.cognome }}</span>
                        </b-col>
                        <b-col cols="4">
                            <label class="sa-data-label">Identificativo</label>
                            <br />
                            <span>{{ this.accessoAppuntamentoSel.identificativoAppuntamento }}</span>
                        </b-col>
                        <b-col cols="6">
                            <label class="sa-data-label">Prestazione</label>
                            <br />
                            <span>{{ this.accessoAppuntamentoSel.descrizionePrestazione }} ({{
                                this.accessoAppuntamentoSel.codicePrestazione }})</span>
                        </b-col>
                        <b-col cols="6">
                            <label class="sa-data-label">Giorno Ora Accesso</label>
                            <br />
                            <span>{{ this.formatDateTime(this.accessoAppuntamentoSel.dataOraInizio) }}</span>
                        </b-col>
                        <b-col cols="12">
                            <label class="sa-data-label">Nota</label>
                            <br />
                            <b-form-textarea v-model="accessoAppuntamentoSel.note" rows="6" max-rows="10"
                                no-resize></b-form-textarea>
                        </b-col>
                    </b-row>
                </b-form>
                <template #modal-footer>
                    <div style="display: flex; gap: 6px; justify-content: flex-end; align-items: center">


                        <b-button variant="success" @click="onClickSalvaNotaOperatore"> Salva Nota
                        </b-button>
                        <!-- <b-button variant="success" v-if="tab == 2 && selectedRowPrenotazione.item.id != '-1'" @click="onPrenotaAppuntamentoNuovaAccettazione()"> Occupa Slot Prestazione </b-button> -->
                    </div>
                </template>
            </b-modal>
            <b-modal ref="mdlChangeStato" @hide="onHideChangeStato" title="Cambio Stato Appuntamento" centered>
                <b-form>
                    <b-row>
                        <b-col cols="10">
                            <label>Stato</label>
                            <b-form-select @change="onChangeSelectStato" v-model="jsonData.stato"
                                :options="orderStutusOptions"></b-form-select>
                        </b-col>

                        <b-col cols="2">
                            <label for=""></label>
                            <b-container class="d-flex gap-3">
                                <b-button variant="outline-primary" @click="onCambiaStato()">
                                    <b-icon icon="gear" aria-hidden="true"></b-icon>
                                </b-button>
                            </b-container>
                        </b-col>
                    </b-row>

                </b-form>

            </b-modal>
            <gestione-appuntamento-modal-component ref="mdlGestioneAppuntamento" @appuntamento-spostato="loadData" />
            <b-modal ref="mdlAggiungiAccesso" @hide="onHideAccessoPaziente" @shown="onShownAccessoDiretto"
                title="Aggiungi Accesso Diretto">
                <b-form>
                    <b-row>
                        <b-col cols="12" v-if="completeRicerca">
                            <label>Barcode Paziente</label>
                            <b-input-group>
                                <b-form-input v-model="barcodePaziente"></b-form-input>
                                <b-input-group-append>
                                    <b-button size="sm" variant="" v-b-tooltip.hover title="Ricerca Paziente"
                                        @click="onCLickRicercaPaziente(barcodePaziente)"><b-icon
                                            icon="search"></b-icon></b-button>
                                </b-input-group-append>
                            </b-input-group>
                        </b-col>
                        <b-col cols="6">
                            <label>Ricetta</label>
                            <b-form-select @change="onChangeRicettaAccessoDiretto" v-model="accessoDiretto.ricettaId">
                                <b-form-select-option v-for="option of ricetteAccessoDirettoOptions" :value="option.id"
                                    :key="option.id">
                                    {{ option.codiceBar1 }} {{ option.codiceBar2 }}
                                </b-form-select-option>
                            </b-form-select>
                        </b-col>
                        <b-col cols="6">
                            <label>Prestazione</label>
                            <b-form-select @change="onChangePrestazioneAccessoDiretto"
                                v-model="accessoDiretto.prestazioneId">
                                <b-form-select-option v-for="option of prestazioneAccessoDirettoOptions"
                                    :value="option.id" :key="option.id">
                                    {{ option.descrizionePrestazione }} ({{ option.codicePrestazione }})
                                </b-form-select-option>
                            </b-form-select>
                        </b-col>
                        <b-col cols="6" v-if="completeBookingSsn">
                            <label>Ambulatorio/Agenda</label>
                            <b-form-select @change="onChangeAmbulatorioAgenda" v-model="accessoDiretto.agendaId">
                                <b-form-select-option v-for="option of agendeAccessoDirettoOptions" :value="option.id"
                                    :key="option.id">
                                    {{ option.titolo }}
                                </b-form-select-option>
                            </b-form-select>
                        </b-col>

                        <!-- <b-col cols="6">
                            <label>Data Ora Accesso</label>
                            <b-form-input :disabled="true" :value="getDescrizioneDataOraAccesso()">
                            </b-form-input>

                        </b-col> -->
                        <b-col cols="12">
                            <label>Seleziona Data Ora Accesso</label>
                            <date-picker v-model="dataRiferimentoAccesso" format="DD-MM-YYYY HH:mm"
                                value-type="timestamp" placeholder="Seleziona Data Ora Accesso" type="datetime"
                                class="w-100" confirm @confirm="onConfirmDataRiferimento"> </date-picker>

                        </b-col>



                        <b-col cols="12" style="padding:8px">
                            <b-row>
                                <b-col :cols="4" class="text-center">
                                    <div class="text-center">
                                        <label class="sa-label-data">Erogabile</label>
                                        <div style=" display: block ruby;">
                                            <div :style="{
                                                minWidth: '22px',
                                                height: '22px',
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                borderRadius: '25px',
                                                background: '#00a3ff',
                                                color: 'white',
                                                fontWeight: '600',
                                                boxShadow: '0 2px 5px rgba(0, 0, 0, 0.2)',
                                            }">{{ accessoDirettoJsonData.ciclo }}
                                            </div>
                                        </div>

                                    </div>
                                </b-col>
                                <b-col :cols="4" class="text-center">
                                    <div class="text-center">
                                        <label class="sa-label-data">Eseguito
                                        </label>
                                        <div style=" display: block ruby;">
                                            <div :style="{
                                                minWidth: '22px',
                                                height: '22px',
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                borderRadius: '25px',
                                                background: '#218838',
                                                color: 'white',
                                                fontWeight: '600',
                                                boxShadow: '0 2px 5px rgba(0, 0, 0, 0.2)',
                                            }">{{ accessoDirettoJsonData.numeroAccessi }}
                                            </div>
                                        </div>

                                    </div>
                                </b-col>
                                <b-col :cols="4" class="text-center">
                                    <div class="text-center">
                                        <label class="sa-label-data">Residuo</label>
                                        <div style=" display: block ruby;">
                                            <div :style="{
                                                minWidth: '22px',
                                                height: '22px',
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                borderRadius: '25px',
                                                background: '#ffc107',
                                                color: 'white',
                                                fontWeight: '600',
                                                boxShadow: '0 2px 5px rgba(0, 0, 0, 0.2)',
                                            }">{{ accessoDirettoJsonData.numeroAccessiMancanti }}
                                            </div>
                                        </div>

                                    </div>
                                </b-col>
                            </b-row>
                        </b-col>
                        <b-col cols="12" class="text-center my-3">
                            <div v-if="!isBtnCreaAccessoDisabled() && callAccessoDirettoComplete"
                                class="d-inline-flex align-items-center justify-content-center p-2 px-3 bg-light rounded-pill border shadow-sm">
                                <span class="font-weight-bold text-dark">Stai creando l'Accesso n°</span>
                                <b-badge variant="primary" class="ml-2 px-2 py-1 font-size-lg rounded-circle">
                                    {{ accessoDirettoJsonData.numeroAccessi + 1 }}
                                </b-badge>
                            </div>
                            <div v-else-if="callAccessoDirettoComplete"
                                class="d-inline-flex align-items-center justify-content-center p-2 px-3 bg-light rounded-pill border shadow-sm">
                                <span class="font-weight-bold text-dark">Ciclo Completo</span>
                                <b-badge variant="primary" class="ml-2 px-2 py-1 font-size-lg rounded-circle">
                                    0
                                </b-badge>
                            </div>
                            <div v-else
                                class="d-inline-flex align-items-center justify-content-center p-2 px-3 bg-light rounded-pill border shadow-sm">
                                <span class="font-weight-bold text-dark">Seleziona</span>
                                <b-badge variant="primary" class="ml-2 px-2 py-1 font-size-lg rounded-circle">
                                    -
                                </b-badge>
                            </div>
                        </b-col>
                        <b-col cols="12">
                            <label>Note Aggiuntive</label>
                            <b-form-textarea rows="2" v-model="accessoDiretto.note">
                            </b-form-textarea>
                        </b-col>
                        <b-col cols="12">
                            <hr style="margin: 18px;" />
                            <div class="sa-ft-card-header" v-b-toggle="'collapse-gruppo-accesso'">
                                <div class="sa-ft-section-icon">🚀</div>
                                <h5>Accessi</h5>
                                <div style="display: table; margin-left: auto; text-align: right;">
                                    <span class="sa-ft-circle-wrapper"> </span>
                                    <div class="sa-ft-section-icon">{{ accessoDirettoJsonData.numeroAccessi }}</div>
                                </div>
                                <span class="sa-ft-arrow-icon sa-ft-circle-wrapper-orange"
                                    :class="{ 'is-open': false }">▼</span>
                            </div>
                            <b-collapse @show="gestisciAperturaAccessi(accessoDirettoJsonData)"
                                @hide="gestisciChiusuraAccessi(accessoDirettoJsonData)" :id="'collapse-gruppo-accesso'">

                                <div class="b-table-sticky-header">
                                    <b-table sticky-header ref="table" stacked="xl" striped hover
                                        :items="accessoDirettoJsonData.accessi" :fields="fieldAccessiPrenotati"
                                        sort-icon-left head-variant="light" class="sa-b-table">
                                        <template #cell(index)="row">
                                            {{ row.index + 1 }}
                                        </template>
                                        <template #cell(numeroOrdine)="row">
                                            <strong style="width: 100%; display: inline-block;">{{
                                                row.item.numeroOrdine }}</strong>

                                        </template>
                                    </b-table>
                                </div>


                            </b-collapse>
                            <div class="sa-ft-card-header" v-b-toggle="'collapse-gruppo-prenotazioni'"
                                v-if="completeBookingSsn">
                                <div class="sa-ft-section-icon">🚀</div>
                                <h5>Prenotazioni</h5>
                                <div style="display: table; margin-left: auto; text-align: right;">
                                    <span class="sa-ft-circle-wrapper"> </span>
                                    <div class="sa-ft-section-icon">{{ accessoDirettoJsonData.numeroPrenotati }}
                                    </div>
                                </div>
                                <span class="sa-ft-arrow-icon sa-ft-circle-wrapper-orange"
                                    :class="{ 'is-open': false }">▼</span>
                            </div>
                            <b-collapse v-if="completeBookingSsn"
                                @show="gestisciAperturaPrenotazioni(accessoDirettoJsonData)"
                                @hide="gestisciChiusuraPrenotazioni(accessoDirettoJsonData)"
                                :id="'collapse-gruppo-prenotazioni'">
                                <div class="b-table-sticky-header">
                                    <b-table sticky-header style="height: 250px !important;" ref="table" stacked="xl"
                                        striped hover responsive :items="accessoDirettoJsonData.prenotati"
                                        :fields="fieldAccessiPrenotati" sort-icon-left head-variant="light"
                                        class="sa-b-table">
                                        <template #cell(index)="row">
                                            {{ row.index + 1 }}
                                        </template>
                                        <template #cell(numeroOrdine)="row">
                                            <strong style="width: 100%; display: inline-block;">{{
                                                row.item.numeroOrdine }}</strong>
                                        </template>
                                    </b-table>
                                </div>


                            </b-collapse>
                        </b-col>

                    </b-row>
                </b-form>
                <template #modal-footer>
                    <div style="display: flex; gap: 6px; justify-content: flex-end; align-items: center">

                        <b-button variant="danger" @click="onAnnullaAccessoDiretto">Annulla</b-button>
                        <b-button variant="success" :disabled="isBtnCreaAccessoDisabled()"
                            @click="aggiungiAccessoDiretto">
                            Crea Accesso
                        </b-button>
                    </div>
                </template>
            </b-modal>
        </div>

    </div>


</template>

<script>
// import axios from "axios";

// import PrintComponent from "../../../utility/components/PdfPrintViewEmbedded.vue";
import UtilityMixin from "../../../utility/UtilityMixin.js";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
// import PrintComponent from "../../../utility/components/PrintComponent.vue";
import moment from "moment";
import toast from "../../../../template/layout/utility/sa-toast.js";
import axios from "axios";
import GestioneAppuntamentoModalComponent from "./GestioneAppuntamentoModalComponent.vue";
export default {
    inject: ["openShowModalLoading", "closeShowModalLoading"],
    //PrintComponent
    mixins: [UtilityMixin],
    components: { DatePicker, GestioneAppuntamentoModalComponent },
    data() {
        return {
            pathResource: "/agendaappuntamenti?barcode=",
            pathResourceRicette: "/accettazionericette",
            items: [],
            righeAperte: [],
            rows: 0,
            completeBookingSsn: this.appConfig.completeBookingSSN,
            barcodePaziente: "",
            accessoDiretto: {
                agendaId: null,
                ricettaId: null,
                prestazioneId: null,
                dataRiferimento: null,
                note: ""
            },
            idAccettazione: null,
            dataRiferimentoAccesso: null,
            jsonData: {
                orderId: null,
                orderStatus: "EROGATO",
                reasonId: 0
            },
            filtro: {
                codiceFiscaleAssistito: null,
                idPresidio: null,
            },
            presidio: {},
            orderStutusOptions: ["ESEGUITO", "NON ESEGUITO"],
            reasonIdOptions: [],
            page: 1,
            perPage: 10000,
            signedPdfViewer: null,
            accessoAppuntamentoSel: {},
            agendaOptions: [],
            listKey: 0,
            previewSelected: null,
            currentPage: 1,
            rowSelectedAccettazione: {},
            dataRiferimento: null,
            listaRicetteDetails: {},
            jsonDataAccettazione: {},

            fieldAccessiPrenotati: [
                {
                    label: "C.F Assistito",
                    key: "identificativoAppuntamento",
                },
                {
                    label: "Prestazione",
                    key: "descrizionePrestazione",
                },
                {
                    label: "Appuntamento",
                    key: "dataOraInizio",
                    formatter: (v) => {
                        return this.formatDateTime(v);
                    }
                },
                {
                    label: "Accesso N°",
                    key: "numeroOrdine",
                },
            ],
            fields: [
                {
                    label: "Nre",
                    key: "nre",
                    thStyle: "width: 8rem",
                },
                {
                    label: "C.F Assistito",
                    key: "identificativoAppuntamento",
                    thStyle: "width: 10rem",
                },
                {
                    label: "Stato",
                    key: "statoAttuale",
                    thStyle: "width: 9rem",
                },
                {
                    label: "Prestazione",
                    key: "descrizionePrestazione",
                    thStyle: "width: 12rem",
                },

                {
                    label: "Ciclo",
                    key: "ciclo",
                    thStyle: "width: 12.5rem",
                },
                {
                    label: "Nota",
                    key: "note",
                    thStyle: "width: 8rem",
                },
                {
                    label: "Appuntamento",
                    key: "riferimento",
                    thStyle: "width: 10rem",
                    sortable: true,
                },
                {
                    label: "",
                    key: "actions",
                    class: "sa-table-column-action-double",
                    thStyle: "width: 8rem",
                    thClass: "text-right",
                    tdClass: "text-right"
                }
            ],

            completeRicerca: false,
            agendeAccessoDirettoOptions: [],
            ricetteAccessoDirettoOptions: [],
            prestazioneAccessoDirettoOptions: [],
            callAccessoDirettoComplete: false,
            accessoDirettoJsonData: {
                numeroAccessi: 0,
                ciclo: 0,
                numeroPrenotati: 0,
                numeroAccessiMancanti: 0,
                accessi: [],
                prenotati: []
            }


        };
    },
    mounted() {
        let tmpPresidio = window.localStorage.getItem("presidio");
        if (tmpPresidio) {
            let presidio = JSON.parse(tmpPresidio);
            this.presidio = presidio;
            this.loadAgende()
        }
        this.idAccettazione = this.$route.query.idAccettazione
        this.filtro.dataRiferimentoAl = new Date().getTime();
        //GESTIONE SE PER PAZIENTE O LISTA RECUPERO TRAMITE BARCODE E POI PRENDO API.
        if (this.idAccettazione) {
            this.loadDataAccettazione();
            this.completeRicerca = false;
        } else {
            this.completeRicerca = true;
        }


    },

    methods: {
        init(filtro, dataRiferimento) {
            this.filtro = filtro;
            this.dataRiferimento = dataRiferimento;
            this.loadData();
        },
        isBtnCreaAccessoDisabled() {
            if (this.accessoDirettoJsonData.numeroAccessiMancanti == 0) {
                return true;
            }
            if (this.accessoDirettoJsonData.appuntamentoPresenteGiornoCorrente) {
                return true;
            }




        },
        sortCompare(aRow, bRow, key) {
            if (key === "riferimento") {
                const aTime = Number(aRow.dataOraInizio) || 0;
                const bTime = Number(bRow.dataOraInizio) || 0;
                return aTime - bTime;
            }
            // per tutte le altre colonne, fallback al comportamento di default di b-table
            return false;
        },
        onClickSalvaNotaOperatore() {
            this.openShowModalLoading();
            let link = process.env.VUE_APP_PATH_API + "/accettazionericetteprestazioniagendaappuntamento/modificanota/" + this.accessoAppuntamentoSel.id;
            axios.put(link, this.accessoAppuntamentoSel)
                .then((response) => {
                    this.closeShowModalLoading()
                    this.$refs.mdlInfo.hide();
                    toast.success(response.data.messaggio);
                    setTimeout(() => {
                        this.loadData();
                    }, 1000);

                })
                .catch((e) => {
                    this.closeShowModalLoading();
                    toast.error(e?.response?.data?.messaggio)

                });

        },
        onClickEliminaAppuntamento(item) {
            console.log(item);

            this.$bvModal
                .msgBoxConfirm("Sei sicuro di voler eliminare questo appuntamento ?", {
                    title: "Eliminazione Appuntamento schedulato",
                    buttonSize: "sm",
                    okTitle: "SI",
                    cancelTitle: "NO",
                    okVariant: "danger",
                    cancelVariant: "secondary",
                    hideHeaderClose: true,
                    footerClass: "p-2",
                    centered: true,
                })
                .then((value) => {
                    if (value) {
                        this.eliminaAppuntamento(item);
                    }
                })
                .catch((error) => {
                    console.log(error);
                });

        },
        validation() {
            let esito = true;
            let msg = "";
            if (!this.barcodePaziente) {
                msg += "Inserire Barcode valido ! #";
                esito = false;
            }



            return { esito: esito, msg: msg };
        },
        onCLickRicercaPaziente(item) {
            this.openShowModalLoading();
            let validation = this.validation();
            if (!validation.esito) {
                toast.validation(validation)
                this.closeShowModalLoading();
                return;
            }
            let filtro = {
                barcode: item,
                cf: item
            }
            this.loadDataResources("/accettazionericetteprestazioniagendaappuntamento/barcode", filtro, this.loadDataBarcodeSuccess, this.loadDataBarcodeError);
        },
        loadDataBarcodeSuccess(response) {
            console.log(response.data.data.ricette);

            this.ricetteAccessoDirettoOptions = response.data.data.ricette;
            this.jsonDataAccettazione = response.data.data;
            this.closeShowModalLoading();

        },
        loadDataBarcodeError() {
            this.closeShowModalLoading();
        },
        eliminaAppuntamento(item) {

            let link = process.env.VUE_APP_PATH_API + "/accettazionericetteprestazioniagendaappuntamento/" + item.id;
            axios.delete(link).then(() => {
                toast.success("Eliminato con successo !")
                this.loadData();
            });
        },
        gestisciAperturaAccessi(item) {
            if (item) {
                this.$set(item, 'isOpenAccessi', true);
            }
            this.isOpen = true;
        },
        gestisciChiusuraAccessi(item) {
            if (item) {
                this.$set(item, 'isOpenAccessi', false);
            }
            this.isOpen = false;
        },
        gestisciAperturaPrenotazioni(item) {
            if (item) {
                this.$set(item, 'isOpenPrenotazioni', true);
            }
            this.isOpen = true;
        },
        gestisciChiusuraPrenotazioni(item) {
            if (item) {
                this.$set(item, 'isOpenPrenotazioni', false);
            }
            this.isOpen = false;
        },
        getGiornoSettimana(dataString) {
            if (!dataString) return '--';
            const giornoSettimana = moment(dataString).locale('it').format('dddd');
            return giornoSettimana;
        },

        giornoSettimanaFormattata(data) {
            if (!data) return '--';
            return moment(data, "DD/MM/YYYY").format("dddd");
        },

        getDescrizioneDataOraAccesso() {
            let returnValue = this.accessoDiretto.dataRiferimento;
            if (this.accessoDiretto.dataRiferimento) {
                let giornoSettimana = this.getGiornoSettimana(this.accessoDiretto.dataRiferimento.split(" ")[0]).toUpperCase();

                returnValue = giornoSettimana + " " + this.formattaDataCustom(returnValue);
            }


            return returnValue;
        },
        onAnnullaAccessoDiretto() {
            this.callAccessoDirettoComplete = false;
            this.$refs.mdlAggiungiAccesso.hide();
        },

        getDescrizioneNumeroTotaleCiclo(row) {
            if (this.jsonDataAccettazione.ricette) {
                if (this.jsonDataAccettazione.ricette.length > 0) {

                    let ricetta = this.jsonDataAccettazione.ricette.find(e => e.id == row.item.idRicettaPrestazione);
                    if (ricetta)
                        return ricetta.quantitaErogabile;
                    else
                        return 0;
                }
            } else {
                return row.item.quantitaErogabileRicetta;
            }
        },

        formattaData(dataString) {
            if (!dataString) return '--';
            const parti = dataString.split('-');
            return `${parti[2]}/${parti[1]}/${parti[0]} `;
        },

        formattaDataCustom(dataString) {
            if (!dataString) return '--';
            const date = dataString.split(' ');
            const parti = date[0].split("-");

            return `${parti[2]}/${parti[1]}/${parti[0]} ${date[1]}`;
        },
        loadData() {
            this.openShowModalLoading();
            this.loadDataResources("/accettazionericetteprestazioniagendaappuntamento/appuntamentiaccessi", this.filtro, this.loadDataAccettazioneSsnSuccess, this.loadDataAccettazioneSsnError);
        },
        loadDataAccettazione() {
            let link = process.env.VUE_APP_PATH_API + "/accettazionessn/" + this.idAccettazione;
            axios.get(link).then((response) => {
                this.jsonDataAccettazione = response.data.data;
            });
        },

        onChangeRicettaAccessoDiretto(id) {
            let ricetta = this.ricetteAccessoDirettoOptions.find(e => e.id == id);
            if (ricetta) {
                this.prestazioneAccessoDirettoOptions = ricetta.prestazioni;
            } else {
                this.prestazioneAccessoDirettoOptions = [];
            }
            if (!this.completeBookingSsn) {
                this.getAccessiPaziente(id);

            }

        },

        onClickAggiungiAccessoDiretto() {
            if (!this.completeRicerca) {
                this.ricetteAccessoDirettoOptions = this.jsonDataAccettazione.ricette;
            }

            this.$refs.mdlAggiungiAccesso.show();
        },
        onChangePrestazioneAccessoDiretto(prestazione) {
            let prestazioneSelezionata = this.prestazioneAccessoDirettoOptions.find(e => e.id == prestazione)
            let codicePrestazione = prestazioneSelezionata.codicePrestazione;
            if (this.completeBookingSsn) {
                this.openShowModalLoading();
                let link = process.env.VUE_APP_PATH_API + "/agende?codicePrestazione=" + codicePrestazione + "&idPresidio=" + this.presidio.idPresidio;
                axios.get(link).then((response) => {
                    this.agendeAccessoDirettoOptions = response.data.data;
                    this.getAccessiPaziente();
                    this.closeShowModalLoading();
                }).catch(() => {
                    this.closeShowModalLoading();
                });

            }


        },
        onChangeAmbulatorioAgenda(a) {
            let agenda = this.agendeAccessoDirettoOptions.find(e => e.id == a)
            console.log(agenda.prestazioni);
        },
        onShownAccessoDiretto() {
            this.accessoDirettoJsonData = {
                numeroAccessi: 0,
                ciclo: 0,
                numeroPrenotati: 0,
                numeroAccessiMancanti: 0,
                accessi: [],
                prenotati: []
            }

            this.dataRiferimentoAccesso = new Date().getTime();
            this.accessoDiretto.dataRiferimento = moment(new Date().getTime()).format("YYYY-MM-DD HH:mm");
            this.prestazioneAccessoDirettoOptions = [];
        },

        onHideAccessoPaziente() {
            this.accessoDiretto = {
                agendaId: null,
                ricettaId: null,
                prestazioneId: null,
                numeroAccessi: 0,
                ciclo: 0,
                numeroPrenotati: 0,
                numeroAccessiMancanti: 0,
                appuntamentoPresenteGiornoCorrente: false,
                accessi: [],
                prenotati: [],
                dataRiferimento: null,
                note: ""
            }
            this.accessoDirettoJsonData = {
                numeroAccessi: 0,
                ciclo: 0,
                numeroPrenotati: 0,
                numeroAccessiMancanti: 0,
                accessi: [],
                prenotati: []
            }
            this.ricetteAccessoDirettoOptions = [];
            this.prestazioneAccessoDirettoOptions = [];
            this.barcodePaziente = null;
        },

        getAccessiPaziente(id) {
            this.openShowModalLoading();
            this.callAccessoDirettoComplete = false;
            let data = this.accessoDiretto.dataRiferimento.split(" ");
            let pathAccessi = this.completeBookingSsn ? "/accessi" : "/accessiricetta";
            let link = process.env.VUE_APP_PATH_API + "/accettazionericetteprestazioni/" + id + pathAccessi + "?dataRiferimento=" + data[0];
            axios.get(link).then((response) => {
                this.accessoDirettoJsonData = response.data.data;
                if (this.completeBookingSsn) {
                    if (this.accessoDirettoJsonData.appuntamentoPresenteGiornoCorrente) {
                        toast.warning("Gia Prevista un'appuntamento per il Paziente per la prestazione!")
                    }
                } else {
                    this.accessoDiretto.agendaId = this.accessoDirettoJsonData.idAgenda;
                }
                this.callAccessoDirettoComplete = true;
                this.closeShowModalLoading();
            }).catch(() => {
                this.closeShowModalLoading();
                this.callAccessoDirettoComplete = true;
            });

        },
        validazioneAccessoDiretto() {
            let esito = true;
            let msg = "";
            if (this.accessoDiretto.agendaId == null) {
                msg += "Seleziona Agenda ! #";
                esito = false;
            }
            if (this.accessoDiretto.ricettaId == null) {
                msg += "Seleziona Ricetta ! #";
                esito = false;
            }
            if (this.accessoDiretto.prestazioneId == null) {
                msg += "Seleziona Prestazione ! #";
                esito = false;
            }

            return { esito: esito, msg: msg };
        },

        aggiungiAccessoDiretto() {

            let validation = this.validazioneAccessoDiretto();
            if (!validation.esito) {
                toast.validation(validation)
                return;
            }
            let prestazioneSelezionata = this.prestazioneAccessoDirettoOptions.find(e => e.id == this.accessoDiretto.prestazioneId)
            let dataRif = this.accessoDiretto.dataRiferimento.split(" ")[0];
            let dataOraInizio = this.convertiInTimestamp(dataRif, this.accessoDiretto.dataRiferimento.split(" ")[1]);
            let dataOraFine = dataOraInizio;
            let appuntamentoAgenda = {
                idAgenda: this.accessoDiretto.agendaId,
                cognome: this.jsonDataAccettazione.accettazioneAnagrafica ? this.jsonDataAccettazione.accettazioneAnagrafica.cognome : "N/D",
                tipoIdentificativo: "CF",
                identificativoAppuntamento: this.jsonDataAccettazione.accettazioneAnagrafica ? this.jsonDataAccettazione.accettazioneAnagrafica.identificativo : "N/D",
                codicePrestazione: prestazioneSelezionata.codicePrestazione,
                descrizionePrestazione: prestazioneSelezionata.descrizionePrestazione,
                dataOraInizio: dataOraInizio,
                dataOraFine: dataOraFine,
                dataRiferimento: dataRif,
                numeroOrdine: this.accessoDirettoJsonData.numeroAccessi + 1,
                costo: prestazioneSelezionata.prezzo,
                nome: this.jsonDataAccettazione.accettazioneAnagrafica ? this.jsonDataAccettazione.accettazioneAnagrafica.nome : "",
                dataNascita: this.jsonDataAccettazione.accettazioneAnagrafica ? this.jsonDataAccettazione.accettazioneAnagrafica.dataNascita : null,
                note: this.accessoDiretto.note,
                statoAttuale: "ESEGUITO",
                idRicettaPrestazione: this.accessoDiretto.prestazioneId,
                statoAttualeDataOra: new Date().getTime()
            };

            this.openShowModalLoading();
            let flux = this.completeBookingSsn ? "1" : "2";
            let link = process.env.VUE_APP_PATH_API + "/accettazionericetteprestazioniagendaappuntamento/accesso?flux=" + flux;
            axios.post(link, appuntamentoAgenda).then(() => {
                this.$refs.mdlAggiungiAccesso.hide();
                this.loadData();
                this.closeShowModalLoading();
            }).catch((err) => {
                this.closeShowModalLoading();
                toast.error(err.response)
            });
        },
        gestioneAppuntamenti(row) {
            this.$refs.mdlGestioneAppuntamento.show(row);
        },
        getOrario(data) {
            return moment(data).format("HH:mm");
        },
        loadAgende() {
            let link = process.env.VUE_APP_PATH_API + "/agende";
            axios
                .get(link, { params: this.filtro })
                .then((response) => {
                    this.agendaOptions = response.data.data;

                })
                .catch((e) => {
                    console.log(e);
                });

        },
        loadDataAccettazioneSsnSuccess(response) {
            this.items = response.data.data;
            this.rows = this.items.length;
            this.closeShowModalLoading();
        },
        loadDataAccettazioneSsnError(response) {
            response;
            this.closeShowModalLoading();

        },
        setData(dataRiferimento) {
            this.dataRiferimento = dataRiferimento;
            this.loadData();
        },

        getInfoAccessoAppuntamento(item) {
            this.accessoAppuntamentoSel = item;

            this.$refs.mdlInfo.show();

            return item.infoAppuntamento;
        },

        getInfoAgenda(item) {
            let returnValue = "";
            let agenda = item.idAgenda;
            let agendaObj = this.agendaOptions.find(e => e.id == agenda);
            if (agendaObj) {
                returnValue = agendaObj.descrizione;
            }
            return returnValue.toUpperCase()
        },
        convertiInTimestamp(data, ora) {

            const dateFinal = `${data}T${ora}:00`;
            return new Date(dateFinal).getTime();



        },
        onHideChangeStato() {
            this.jsonData = {}
        },
        onHideInfoModal() {
            this.accessoAppuntamentoSel = {}
        },
        onConfirmDataRiferimento(r) {
            if (r) {
                if (moment(r).isAfter(moment())) {
                    toast.error("Non è possibile inserire una data/ora futura");
                    return;
                }
                this.accessoDiretto.dataRiferimento = moment(r).format("YYYY-MM-DD HH:mm");
            } else {
                this.accessoDiretto.dataRiferimento = null;
            }
        },

        onChangeStatoPrenotazione(item) {
            this.appuntamentoSel = item;
            this.$refs.mdlChangeStato.show();
        },
        onChangeSelectStato(params) {
            if (params == 'PRENOTATO' || params == "ACCETTATO" || params == "EROGATO") {
                this.jsonData.reasonId = 0;
            }
        },
        onCambiaStato() {
            this.openShowModalLoading();
            console.log("agendaappuntamentistatistorico");
            let request = {
                stato: this.jsonData.stato,
                idAppuntamento: this.appuntamentoSel.id,
                dataOra: new Date().getTime(),
            }
            let link = process.env.VUE_APP_PATH_API + "/agendaappuntamentistatistorico";
            axios.post(link, request).then(() => {
                toast.success("Cambio stato avvenuto con successo: " + this.jsonData.stato)
                this.loadData();
                this.closeShowModalLoading();
                this.$refs.mdlChangeStato.hide();
            }).catch((erro) => {
                erro;
                this.closeShowModalLoading();
            });
        },

    },
};
</script>

<style scoped>
.sa-card-list-scroll {
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden !important;
}

.sa-card-list-scroll ::v-deep .card-body {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.sa-card-list-scroll .b-table-sticky-header {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
}

.ft-wrapper-ricetta {
    margin-bottom: 16px;
}

.compact-number-container {
    display: inline-flex;
    padding: 8px;
    flex-direction: column;
    align-items: center;
}



.sa-ft-section-icon {
    font-size: 1rem;
    background: #f1f5f9;
    width: 28px;
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
}

.ft-ricetta-titolo {
    font-weight: 600;
    display: block;
    margin-bottom: 8px;
}

/* Prestazioni orizzontali */
.ft-wrapper-prestazioni {
    display: flex;

    gap: 16px;
}

.ft-prestazione-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 8px;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    background: #f9f9f9;
}

.ft-prestazione-codice {
    font-weight: 600;
    margin-bottom: 6px;
}

.ft-prestazione-badge-container {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 12px;
}

.ft-badge {
    min-width: 22px;
    height: 22px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    color: white;
    font-weight: 600;
}

.ft-badge-complete {
    background-color: #00a3ff;
}

.ft-badge-incomplete {
    background-color: #ffc107;
}

.ft-badge-total {
    background-color: #00a3ff;
}

.sa-badge-internal {
    border-radius: 5px;
    border-left: 4px solid var(--bg-sidebar-item);
    border-top: 1px solid var(--bg-main-nav-bar);
    border-bottom: 1px solid var(--bg-main-nav-bar);
    border-right: 1px solid var(--bg-main-nav-bar);
    padding: 7px !important;
    margin-bottom: 5px;
    max-width: max-content;
}

.sa-badge {
    width: 100%;
    max-width: none !important;
}
</style>
